import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";

export const Clausulas = ({ clausulas }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Clausulas"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Item</th>
                                        <th>Clausula</th>
                                        <th className="text-right">Valor Limite</th>
                                        <th>Observaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {clausulas.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={4}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {clausulas.map((item, index) => (
                                                <tr key={item.cdClausulaNegocio}>
                                                    <td>
                                                        <span>{index + 1}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.nmClausula}</span>
                                                    </td>
                                                    <td className="text-right">
                                                        <span>
                                                            <ReactNumeric
                                                                valuex={item.valLimite ? item.valLimite : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.obsClausulasNegocio}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
